<template>
  <TheDialog :open="props.open">
    <template #header>
      <TheDialogHeader :title="title" @click="emit('dialog:close')" />
      <UiDialogDescription />
    </template>
    <template #content>
      <div class="relative flex flex-col w-full">
        <div class="flex w-full text-center place-content-center">
          {{ text }}
        </div>

        <UiButton
          class="!iq-button-success self-center lg:px-16 items-center mt-4 w-[120px]"
          @click="emit('dialog:close')"
          >OK</UiButton
        >
      </div>
    </template>
  </TheDialog>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'dialog:close'): void;
}>();

const props = defineProps<{
  open: boolean;
  text: string;
  title: string;
}>();
</script>
